import React from "react";
import Seo, { faqJsonLd, breadcrumbJsonLd } from "@/components/Seo";
import PageHero from "@/components/ui-kit/PageHero";
import { Container, Section } from "@/components/ui-kit/Section";
import { Reveal } from "@/components/motion/Reveal";
import FaqAccordion from "@/components/blocks/FaqAccordion";
import Cta from "@/components/ui-kit/Cta";
import { FAQ_GROUPS } from "@/lib/site";

const GROUP_CTA = {
  "getting-started": { label: "Start Free Setup", to: "/get-started", variant: "primary" },
  "security-trust": { label: "See how it works", to: "/how-it-works", variant: "outline" },
  "money-movement": { label: "Start Free Setup", to: "/get-started", variant: "primary" },
  agencies: { label: "Book a Walkthrough", to: "/agencies", variant: "primary" },
  fees: { label: "See full pricing", to: "/pricing", variant: "outline" },
};

const ALL_ITEMS = FAQ_GROUPS.flatMap((g) => g.items);

export default function Faq() {
  return (
    <>
      <Seo
        title="ETAP FAQ | Security, money movement, fees, agencies"
        description="Answers on how ETAP works: read only bank access, who moves your money, the flat 0.5 percent fee, consent, and agency commissions. Get started free."
        path="/faq"
        jsonLd={[
          faqJsonLd(ALL_ITEMS),
          breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: "FAQ", path: "/faq" },
          ]),
        ]}
      />

      <PageHero
        eyebrow="Questions and answers"
        title="Everything you might ask before you start"
        subtitle="Grouped by topic and grounded in exactly what ETAP does. If something is not here, our team is happy to help."
      />

      <Section className="bg-canvas pt-4">
        <Container>
          <div className="mx-auto max-w-3xl space-y-12">
            {FAQ_GROUPS.map((group) => {
              const cta = GROUP_CTA[group.id];
              return (
                <Reveal key={group.id}>
                  <div className="rounded-3xl border border-etap-deep-100 bg-white p-6 shadow-etap-sm sm:p-8" data-testid={`faq-group-${group.id}`}>
                    <h2 className="font-display text-2xl font-bold tracking-tight text-etap-deep-900">{group.title}</h2>
                    <div className="mt-4">
                      <FaqAccordion items={group.items} idPrefix={`faq-${group.id}`} />
                    </div>
                    {cta && (
                      <div className="mt-6 border-t border-etap-deep-50 pt-6">
                        <Cta to={cta.to} variant={cta.variant} location={`faq-${group.id}`} withArrow testId={`faq-cta-${group.id}`}>
                          {cta.label}
                        </Cta>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </Container>
      </Section>
    </>
  );
}
